import apiClient from './api.service';
import { AnalyticsData, ResponseDistribution } from '../types/analytics.types';

// Phase 7 - US5: Analytics Service (T128)

export const analyticsService = {
  async getSurveyAnalytics(surveyId: string): Promise<AnalyticsData> {
    const response = await apiClient.get(`/api/surveys/${surveyId}/analytics`);
    return response.data.data;
  },

  async getCrossTabulation(
    surveyId: string,
    questionId: string,
    demographicField: string,
    demographicValue: string
  ): Promise<ResponseDistribution> {
    const response = await apiClient.get(
      `/api/surveys/${surveyId}/analytics/cross-tab`,
      {
        params: {
          questionId,
          demographicField,
          demographicValue,
        },
      }
    );
    return response.data.data;
  },
};

export default analyticsService;
